import React from 'react';
import { useIntl } from 'react-intl';

const AdminFTPQueueListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th>
        &nbsp;
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'File name' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Account login' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Added' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Status' })}
      </th>
    </tr>
  );
};

export default AdminFTPQueueListHeader;
